import { action } from "../common/Action"
import { TipiContrattoClient, TipoContratto } from "../generated";

const service = new TipiContrattoClient();

class TipiContrattoActions {
    @action
    async add(tipoContratto: TipoContratto) {
        await service.addTipoContratto(tipoContratto);
        return (await service.getAllTipiContratto())!
    }
    @action
    async update(tipoContratto: TipoContratto) {
        await service.updateTipoContratto(tipoContratto);
        return (await service.getAllTipiContratto())!
    }
    @action
    async getAll() {
        return (await service.getAllTipiContratto())!;
    };
}
export default new TipiContrattoActions();